import { Link } from "react-router-dom";
import "./BackLink.css";

const BackLink = () => (
  <Link to="/" className="back-link" aria-label="Zurück zur Startseite">
    <span className="back-link-arrow" aria-hidden="true">
      ←
    </span>
    Zurück
  </Link>
);

export default BackLink;
